import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import UiVersionSwitcher from '@/components/ui/custom/UiVersionSwitcher';
import useAuth from '@/data/hook/useAuth';
import { isStaff } from '@/functions/auth';
import CourseLessonsPage from '@/pages/course-lessons/CourseLessonsPage';
import CoursesPage from './CoursesPage';

export default function CoursesPageSwitcher() {
  const { user } = useAuth();

  return (
    <ConditionalRenderer
      condition={!!isStaff(user?.userType)}
      fallback={<CoursesPage />}
    >
      <UiVersionSwitcher scope="staffCourseLessons">
        <UiVersionSwitcher.Legacy>
          <CoursesPage />
        </UiVersionSwitcher.Legacy>
        <UiVersionSwitcher.Modern>
          <CourseLessonsPage />
        </UiVersionSwitcher.Modern>
      </UiVersionSwitcher>
    </ConditionalRenderer>
  );
}
